import gql from 'graphql-tag';

const key = `CreatePeriodPlanResult`;
const mutation = gql`
mutation ${key}($input:CreatePeriodPlanResultInput!) {
  createPeriodPlanResult(input:$input){
    id
    name
    targetHourLyCustomers
    actualHourLyCustomers
    targetWeeklyGp
    actualWeeklyGp
    targetWeeklyUpt
    actualWeeklyUpt
    targetWagePercent
    actualWagePercent
  }
}
`;

export const CREATE_PERIOD_PLAN_RESULT = { key, mutation };
